/* pdp-sticky-bar.js - mitlaufende Kaufleiste der PDP (mobil, Phase 1 Baustein 3)

   Wird nur geladen, wenn main-product das Setting sticky_buy_bar an hat und
   das Produkt KEINEN Widerrufsausschluss hat (custom.widerruf_hinweis, FLUM).

   Kein eigener Warenkorb-Pfad: Die Leiste klickt den Inline-Button der PDP
   (bindAtc -> window.Cart.add mit Menge und Fehleranzeige) bzw. den
   Benachrichtigen-Button (Notify-Modal mit data-notify-variant). Den Zustand
   des Inline-Buttons (Text, Laden, Benachrichtigen) spiegelt sie per
   MutationObserver, nicht ueber cart:add-Events (die feuern auch fuer
   Cross-Sell und Drawer-Upsells).

   Sichtbar nur, wenn ALLE Bedingungen gelten:
     - Viewport unter 1024 px
     - Hauptbild (.pdp__main-wrap) nicht im Bild
     - Kaufbereich (.pdp__cta) OBEN aus dem Bild, also schon vorbeigescrollt
       (liegt er noch unter dem Falz, bleibt die Leiste weg); der IntersectionObserver zieht
       die Leistenhoehe unten ab (rootMargin), sonst gaelte ein CTA hinter
       der Leiste schon als sichtbar und die Leiste wuerde flackern, und oben
       die Hoehe des klebenden Headers (was dahinter liegt, ist nicht im Bild)
     - keine Texteingabe fokussiert (Tastatur, z. B. Header-Suche)
   Liegt der Tastaturfokus in der Leiste, bleibt sie stehen (kein inert, das
   wuerde den Fokus verlieren).

   Variantenwechsel: main-product feuert pdp:variant-change mit Titel, Preis,
   Grundpreis und Bild-URL. Startzustand kommt aus dem Server-HTML bzw. aus
   section.pdpVariantDetail, falls schon vor dem Start gewechselt wurde.

   CSS: assets/main-product.css (Abschnitt "Mitlaufende Kaufleiste"). Die
   Leiste setzt am html-Element:
     has-pdp-sticky       - Footer bekommt unten Platz in Footer-Farbe
     pdp-sticky-visible   - Inbox-Chat-Bubble rueckt hoch, scroll-padding
     --pdp-sticky-h       - gemessene Leistenhoehe */
(function () {
  'use strict';

  var bar = document.querySelector('[data-pdp-sticky]');
  var section = document.querySelector('[data-pdp]');
  if (!bar || !section || !('IntersectionObserver' in window) || !window.matchMedia) return;

  var cta = section.querySelector('.pdp__cta');
  var media = section.querySelector('.pdp__main-wrap');
  var actionBtn = bar.querySelector('[data-sticky-action]');
  if (!cta || !actionBtn) return;

  var metaBtn = bar.querySelector('[data-sticky-scroll]');
  var titleEl = bar.querySelector('[data-sticky-title]');
  var priceEl = bar.querySelector('[data-sticky-price]');
  var unitEl = bar.querySelector('[data-sticky-unit]');
  var unitTextEl = bar.querySelector('[data-sticky-unit-text]');
  var imgEl = bar.querySelector('[data-sticky-img]');
  var errorEl = section.querySelector('[data-atc-error]');

  var root = document.documentElement;
  var desktopMq = window.matchMedia('(min-width: 1024px)');
  var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');

  var ctaInView = true;    /* bis der Observer meldet: so startet die Leiste versteckt */
  /* Kaufbereich OBEN aus dem Bild (schon vorbeigescrollt). "Nicht im Bild"
     allein reicht nicht: Liegt der Kaufbutton unter dem Falz (lange Titel,
     viele Optionen), waere er vor dem Erreichen ebenfalls "nicht im Bild" und
     die Leiste blitzte beim ersten Scrollen kurz auf (Inhaber, 15.10.2026). */
  var ctaPassed = false;
  var mediaInView = !!media;
  var typing = false;
  var visible = false;
  var pending = false;     /* Leiste hat einen Warenkorb-Request ausgeloest */
  var imgLoaded = false;
  var imgSrc = '';         /* zuletzt gesetzte Hintergrund-URL des Vorschaubilds */
  var barH = 0;
  var headerH = 0;
  var io = null;
  var headerEl = document.getElementById('site-header');

  function scrollBehavior() {
    return reduceMq.matches ? 'auto' : 'smooth';
  }

  function inlineButton() {
    return cta.querySelector('[data-pdp-atc], [data-notify-me]');
  }

  function focusInBar() {
    return bar.contains(document.activeElement);
  }

  /* Nur Tastaturfokus haelt die Leiste offen. Ein Tap (Chrome Android
     fokussiert Buttons) soll sie nicht festhalten. */
  function keyboardFocusInBar() {
    var el = document.activeElement;
    if (!el || !bar.contains(el)) return false;
    try { return el.matches(':focus-visible'); } catch (e) { return false; }
  }

  /* Eingaben in modalen Dialogen (Benachrichtigen-Modal, Groessentabelle)
     zaehlen nicht: deren Backdrop liegt ohnehin ueber der Leiste, und die
     Leiste bleibt fokussierbar, damit der Dialog den Fokus beim Schliessen
     an den Leisten-Button zurueckgeben kann. */
  function isTextEntry(el) {
    if (!el || el === document.body || bar.contains(el)) return false;
    if (el.closest && el.closest('[aria-modal="true"]')) return false;
    if (el.isContentEditable) return true;
    var tag = el.tagName;
    if (tag === 'TEXTAREA') return true;
    if (tag !== 'INPUT') return false;
    var type = (el.getAttribute('type') || 'text').toLowerCase();
    return ['button', 'submit', 'reset', 'checkbox', 'radio', 'range', 'color', 'file', 'image', 'hidden'].indexOf(type) === -1;
  }

  /* Vorschaubild = Hintergrund des span[data-sticky-img] (dekorativ, kein
     img ohne src im Markup). Anfuehrungszeichen in der URL maskieren. */
  function setImage(src) {
    if (!imgEl || !src || src === imgSrc) return;
    imgSrc = src;
    imgEl.style.backgroundImage = 'url("' + String(src).replace(/["\\\n\r]/g, encodeURIComponent) + '")';
  }

  /* ── Sichtbarkeit ── */
  function loadImage() {
    if (imgLoaded || !imgEl) return;
    setImage(imgEl.getAttribute('data-src'));
    imgLoaded = true;
  }

  function setVisible(show) {
    if (show === visible) return;
    visible = show;
    if (show) {
      loadImage();
      bar.removeAttribute('inert');
      bar.removeAttribute('aria-hidden');
    } else {
      /* Zeiger-Fokus (Tap) vorher loesen, damit inert keinen fokussierten
         Knoten versteckt. */
      if (focusInBar() && document.activeElement && document.activeElement.blur) {
        document.activeElement.blur();
      }
      bar.setAttribute('aria-hidden', 'true');
      bar.setAttribute('inert', '');
    }
    bar.classList.toggle('is-visible', show);
    root.classList.toggle('pdp-sticky-visible', show);
  }

  function update() {
    var show = !desktopMq.matches && !ctaInView && ctaPassed && !mediaInView && !typing;
    if (!show && visible && keyboardFocusInBar()) return;
    setVisible(show);
  }

  /* ── Messen + Beobachten ── */
  /* Der Header klebt oben (sticky, section-header.css). Was dahinter liegt,
     ist nicht zu sehen: seine Hoehe zieht der Observer oben ab, sonst kaeme
     die Leiste eine Header-Hoehe zu spaet und ginge beim Hochscrollen zu
     frueh. Direkt gemessen, nicht ueber --header-total-height (die Variable
     setzt section-header.js in einem eigenen ResizeObserver, Reihenfolge
     offen). */
  function measure() {
    var h = desktopMq.matches ? 0 : Math.round(bar.offsetHeight || 0);
    var hh = headerEl ? Math.round(headerEl.getBoundingClientRect().height || 0) : 0;
    if (h === barH && hh === headerH && io) return;
    root.style.setProperty('--pdp-sticky-h', h + 'px');
    barH = h;
    headerH = hh;
    observe();
  }

  function observe() {
    if (io) io.disconnect();
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === cta) {
          ctaInView = entry.isIntersecting;
          /* Oberkante des beobachteten Bereichs = unter dem klebenden Header.
             rootBounds fehlt nur in fremden iframes, dann Header-Hoehe. */
          var topEdge = entry.rootBounds ? entry.rootBounds.top : headerH;
          ctaPassed = !entry.isIntersecting && entry.boundingClientRect.bottom <= topEdge;
        } else if (entry.target === media) {
          mediaInView = entry.isIntersecting;
        }
      });
      update();
    }, { rootMargin: '-' + headerH + 'px 0px -' + barH + 'px 0px', threshold: 0 });
    io.observe(cta);
    if (media) io.observe(media);
  }

  root.classList.add('has-pdp-sticky');
  measure();

  function onMqChange() {
    measure();
    update();
  }
  if (desktopMq.addEventListener) desktopMq.addEventListener('change', onMqChange);
  else if (desktopMq.addListener) desktopMq.addListener(onMqChange);

  if (window.ResizeObserver) {
    var ro = new ResizeObserver(function () { measure(); });
    ro.observe(bar);
    if (headerEl) ro.observe(headerEl);
  } else {
    window.addEventListener('resize', measure);
  }

  /* ── Texteingabe: Leiste weg, solange die Tastatur offen ist ── */
  document.addEventListener('focusin', function (e) {
    typing = isTextEntry(e.target);
    update();
  });
  document.addEventListener('focusout', function () {
    setTimeout(function () {
      typing = isTextEntry(document.activeElement);
      update();
    }, 0);
  });

  /* ── Inline-Button spiegeln ── */
  function syncButton() {
    var src = inlineButton();
    if (!src) {
      actionBtn.setAttribute('aria-disabled', 'true');
      return;
    }
    var notify = src.hasAttribute('data-notify-me');
    var label = (src.textContent || '').replace(/\s+/g, ' ').trim();
    /* Waehrend des Ladens setzt bindAtc den Inline-Text auf ein Auslassungs-
       zeichen. Das NICHT spiegeln: der Leisten-Button wuerde schrumpfen und
       die Leiste springen; den Ladezustand zeigen aria-busy/aria-disabled. */
    if (label && !src.disabled && actionBtn.textContent !== label) actionBtn.textContent = label;
    actionBtn.classList.toggle('btn-wipe-inverse', notify);
    /* aria-disabled statt disabled: ein fokussierter Button behaelt den Fokus */
    actionBtn.setAttribute('aria-disabled', src.disabled ? 'true' : 'false');
    if (!notify && src.disabled) actionBtn.setAttribute('aria-busy', 'true');
    else actionBtn.removeAttribute('aria-busy');
  }

  /* Fehler nach einem Klick in der Leiste: Inline-Fehlerzeile zeigen. Ist der
     Warenkorb-Drawer offen (ab Batch 2 steht der Fehler dort), nicht scrollen. */
  function revealError() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer && drawer.classList.contains('is-open')) return;
    var hadFocus = focusInBar();
    try {
      cta.scrollIntoView({ block: 'center', behavior: scrollBehavior() });
    } catch (e) {
      cta.scrollIntoView();
    }
    if (hadFocus) {
      var src = inlineButton();
      if (src) {
        try { src.focus({ preventScroll: true }); } catch (e) { src.focus(); }
      }
    }
  }

  if (window.MutationObserver) {
    var mo = new MutationObserver(function () {
      if (pending && errorEl && errorEl.classList.contains('is-visible')) {
        pending = false;
        revealError();
      }
      syncButton();
      var src = inlineButton();
      if (pending && (!src || !src.disabled)) pending = false;
    });
    mo.observe(cta, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'class']
    });
    if (errorEl) mo.observe(errorEl, { attributes: true, attributeFilter: ['class'], childList: true });
  }
  syncButton();

  /* ── Aktionen ── */
  actionBtn.addEventListener('click', function () {
    if (actionBtn.getAttribute('aria-disabled') === 'true') return;
    var src = inlineButton();
    if (!src || src.disabled) return;
    if (src.hasAttribute('data-pdp-atc')) {
      pending = true;
      src.click();
      /* bindAtc sperrt den Button synchron; ist er frei, lief nichts an */
      if (!src.disabled) pending = false;
    } else {
      src.click();
    }
  });

  if (metaBtn) {
    metaBtn.addEventListener('click', function () {
      var target = section.querySelector('.pdp__option:not(.pdp__option--qty)') ||
        section.querySelector('.pdp__header');
      if (!target) return;
      try {
        target.scrollIntoView({ block: 'start', behavior: scrollBehavior() });
      } catch (e) {
        target.scrollIntoView();
      }
      /* Fokus auf das Bedienelement der Auswahl (Dropdown bzw. gewaehlte
         Farbe), damit Tastatur und Screenreader dort weitermachen. */
      var ctl = target.querySelector('[data-option-toggle]') ||
        target.querySelector('.pdp__swatch.is-selected') ||
        target.querySelector('button:not([disabled]), select, input');
      if (ctl) {
        try { ctl.focus({ preventScroll: true }); } catch (e) { /* alter Browser: kein Fokuswechsel */ }
      }
    });
  }

  /* ── Variantenwechsel ── */
  function applyVariant(d) {
    d = d || {};
    if (titleEl && d.title) titleEl.textContent = d.title;
    if (priceEl && d.price) priceEl.textContent = d.price;
    if (unitEl && unitTextEl) {
      unitTextEl.textContent = d.unit || '';
      unitEl.hidden = !d.unit;
    }
    if (imgEl) {
      var src = d.image || imgEl.getAttribute('data-fallback-src') || '';
      if (src) {
        imgEl.setAttribute('data-src', src);
        if (imgLoaded) setImage(src);
      }
    }
    syncButton();
  }

  section.addEventListener('pdp:variant-change', function (e) {
    applyVariant(e && e.detail);
  });

  /* Wurde schon vor dem Start dieses (defer-)Skripts eine Variante gewaehlt
     (langsame Verbindung), liegt der letzte Stand an der Section: sonst
     zeigte die Leiste Titel und Preis der Server-Variante. */
  if (section.pdpVariantDetail) applyVariant(section.pdpVariantDetail);
})();
